import { takeEvery, put, call } from 'redux-saga/effects'
import { push } from 'connected-react-router'
import { IDENTITY_LOGOUT_REQUEST } from '../actionTypes'
import { logoutSuccess } from '../actions'
import { persistor } from 'store'

export default function* logoutSaga() {
  yield takeEvery(IDENTITY_LOGOUT_REQUEST, handleLogout)
}

export function* handleLogout() {
  yield call(persistor.flush)
  yield put(logoutSuccess())
  yield put(push('/login'))
}
